<template>
  <div class="import-contacts">
    <page-header title="Import Your Contact(s)" breadcrumb="Dashboard > CRM > Import Contacts"
      :back="{ name: 'CRM' }" />
    <div class="bg-white py-12">
      <div class="import w-3/4 mx-auto">
        <div class="py-8">
          <div>
            <p class="text-center text-sm">
              Use this contacts CSV template
              <span class="text-primary-blue cursor-pointer">here</span> as a
              guide in creating your csv file to upload your contact.
            </p>
          </div>
        </div>

        <div class="import-area bg-grey py-20  rounded">
          <div class="flex justify-center">
            <base-input placeholder="No file Chosen" :value="file.name" disabled />
            <base-button text="Choose File" background="bg-darkBlue" color="text-white" @click="$refs.file.click()" />
          </div>
          <div class="flex justify-center hidden">
            <input type="file" ref="file" @change="handleFileUpload" />
          </div>
          <div>
            <p class="font-semibold text-sm text-center">*Select a .CSV file</p>
          </div>
        </div>

        <div class="actions flex mt-8 justify-between">
          <div>
            <p class="cursor-pointer" @click="$router.go(-1)">Cancel</p>
          </div>
          <div>
            <base-button text="Import" :loading="loading" @click="submitFile" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/UI/NewPageHeader'
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      file: '',
      fileName: '',
      loading: false,
    }
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
      console.log(this.file)
    },
    async submitFile() {
      this.loading = true
      let formData = new FormData()
      formData.append('file', this.file)
      try {
        const response = await this.$_importContact(formData)
        console.log(response)
        this.generateToast('Your file has been uploaded!', 'success')
      } catch (error) {
        this.handleError(error)
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.card {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.import-area {
  background: #f8faf9;
}
</style>
